import { Container, Box, Typography } from "@mui/material";

import GrayPaper from "../../atoms/GrayPaper";

const AccountAccessLayout = ({
  title,
  error,
  sidePanel,
  footer,
  children
}) => {
  const containerMaxWidth = sidePanel ? "lg" : "sm";
  const titleVariant = sidePanel ? "h3" : "h2";

  const header = (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      <img
        src="/images/aclymate-full-logo.png"
        alt="Aclymate Logo"
        width={250}
      />
      <Typography variant={titleVariant} align="center">
        {title}
      </Typography>
    </Box>
  );

  // GrayPaper/DefaultPaper renders an inner Box wrapping `children` that is
  // separate from the outer Paper — `sx` lands on the outer Paper (which has
  // only that one child, so flex/gap there is a no-op). Layout for the
  // children themselves has to go through `boxStyle` instead (see other
  // GrayPaper call sites for the same convention).
  const formCard = (
    <GrayPaper
      boxStyle={{
        padding: 24,
        display: "flex",
        flexDirection: "column",
        gap: 16
      }}
    >
      {children}
    </GrayPaper>
  );

  const body = sidePanel ? (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "stretch",
        gap: 4,
        "& > *": { flex: 1 }
      }}
    >
      {sidePanel}
      {formCard}
    </Box>
  ) : (
    formCard
  );

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      py={4}
    >
      <Container maxWidth={containerMaxWidth}>
        <Box display="flex" flexDirection="column" gap={4}>
          {header}
          {body}
          {error && (
            <Typography variant="body1" align="center" color="error">
              {error}
            </Typography>
          )}
          {footer && (
            <Box display="flex" justifyContent="center">
              {footer}
            </Box>
          )}
        </Box>
      </Container>
    </Box>
  );
};
export default AccountAccessLayout;
